import { render, staticRenderFns } from "./comConditionalBuilderV2.vue?vue&type=template&id=2ff2374e"
import script from "./comConditionalBuilderV2.vue?vue&type=script&lang=js"
export * from "./comConditionalBuilderV2.vue?vue&type=script&lang=js"
import style0 from "./comConditionalBuilderV2.vue?vue&type=style&index=0&id=2ff2374e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports